import { request } from '@/utils/request'

// Sorted by descending priority
export const BOARD_ROLE_NAMES = {
    CHM: 'Chairman',
    IND: 'Independent Director',
    BRD: 'Member',
}

export const BOARD_ROLES = Object.keys(BOARD_ROLE_NAMES)

export function getRoleName(role) {
    return BOARD_ROLE_NAMES[role]
}

export function isBoardRole(role) {
    return BOARD_ROLES.includes(role)
}

const JobsService = {
    async get(id) {
        return request.get(`/api/manage/jobs/${id}`)
    },
    async update(id, job) {
        return request.put(`/api/manage/jobs/${id}`, job)
    },

    async listByCompanyId(companyId) {
        let response = await request.get(`/api/manage/companies/${companyId}/jobs`)

        let executives = []

        response.executives.forEach(e => (executives[e.id] = { ...e, jobs: [], titles: [], roles: [], boardRoles: [] }))
        response.jobs.forEach(j => executives[j.executiveId].jobs.push(j))
        response.titles.forEach(t => executives[t.executiveId].titles.push(t))
        response.roles.forEach(r =>
            isBoardRole(r.role) ? executives[r.executiveId].boardRoles.push(r) : executives[r.executiveId].roles.push(r)
        )

        executives = Object.values(executives).sort((lhs, rhs) => lhs.colloquialName.localeCompare(rhs.colloquialName))

        executives.forEach(e => {
            e.jobs.sort((lhs, rhs) => (rhs.startDate ?? '').localeCompare(lhs.startDate ?? ''))
            e.titles.sort((lhs, rhs) => (rhs.startDate ?? '').localeCompare(lhs.startDate ?? ''))
            e.roles.sort((lhs, rhs) => (rhs.startDate ?? '').localeCompare(lhs.startDate ?? ''))
            e.boardRoles.sort((lhs, rhs) => (rhs.startDate ?? '').localeCompare(lhs.startDate ?? ''))
        })

        return executives
    },

    async listByExecutiveId(executiveId) {
        var response = await request.get(`/api/manage/executives/${executiveId}/jobs`)

        let companies = []

        response.companies.forEach(c => (companies[c.id] = { ...c, jobs: [], roles: [], titles: [] }))
        response.jobs.forEach(j => companies[j.companyId].jobs.push(j))
        response.roles.forEach(r => companies[r.companyId].roles.push(r))
        response.titles.forEach(t => companies[t.companyId].titles.push(t))

        companies = Object.values(companies).sort((lhs, rhs) => lhs.name.localeCompare(rhs.name))

        companies.forEach(c => {
            c.confirmedDate =
                c.jobs.length === 0
                    ? null
                    : // Take the most recent confirmed date
                      c.jobs
                          .map(j => j.confirmedDate)
                          .sort((a, b) => b.localeCompare(a))[0]
                          .substring(0, 10)

            c.jobs.sort((lhs, rhs) => (rhs.startDate ?? '').localeCompare(lhs.startDate ?? ''))
            c.roles.sort((lhs, rhs) => (lhs.role ?? '').localeCompare(rhs.role ?? ''))
            c.titles.sort((lhs, rhs) => (rhs.startDate ?? '').localeCompare(lhs.startDate ?? ''))
        })

        return companies
    },
    patch(executiveId, changeset) {
        return request.patch(`/api/manage/executives/${executiveId}/jobs`, changeset)
    },
    destroyCompany(executiveId, company) {
        return this.patch(executiveId, {
            companyId: company.id,
            jobs: company.jobs.map(j => ({ ...j, id: -j.id })),
            roles: company.roles.map(r => ({ ...r, id: -r.id })),
            titles: company.titles.map(t => ({ ...t, id: -t.id })),
        })
    },
}

export default JobsService
